
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { logout } from "../redux/slice";

// Components
import Sidebar from "./admin/Sidebar";
import Topbar from "./admin/Topbar";
import DashboardSection from "./admin/DashboardSection";
import UserManagementSection from "./admin/UserManagementSection";
import ContentApprovalsSection from "./admin/ContentApprovalsSection";
import ReportsModerationSection from "./admin/ReportsModerationSection";
import SubscriptionPlansSection from "./admin/SubscriptionPlansSection";
import ContentManagementSection from "./admin/ContentManagementSection";
import PaymentList from "./admin/PaymentTracker";
import UserProfile from "./admin/userprofile";

// Import CSS
import "../styles/layout.css";

const DashboardDetails = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("dashboard");

  useEffect(() => {
    const path = location.pathname;

    if (path.includes("/admin/dashboard")) {
      setActiveSection("dashboard");
    } else if (path.includes("/admin/users") || path.includes("/admin/user-management")) {
      setActiveSection("users");
    } else if (path.includes("/admin/approvals") || path.includes("/admin/content-approvals")) {
      setActiveSection("approvals");
    } else if (path.includes("/admin/reports") || path.includes("/admin/reports-moderation")) {
      setActiveSection("reports");
    } else if (path.includes("/admin/subscriptions") || path.includes("/admin/subscription-plans")) {
      setActiveSection("subscriptions");
    } else if (path.includes("/admin/cms") || path.includes("/admin/content-management")) {
      setActiveSection("cms");
    } else if (path.includes("/admin/payments") || path.includes("/admin/payment-list")) {
      setActiveSection("payments");
    } else if (path.includes("/admin/user-profile")) {
      setActiveSection("user-profile");
    }
  }, [location.pathname]);

  const handleSectionChange = (section) => {
    setActiveSection(section);

    switch (section) {
      case "dashboard":
        navigate("/admin/dashboard");
        break;
      case "users":
        navigate("/admin/user-management");
        break;
      case "approvals":
        navigate("/admin/content-approvals");
        break;
      case "reports":
        navigate("/admin/reports-moderation");
        break;
      case "subscriptions":
        navigate("/admin/subscription-plans");
        break;
      case "cms":
        navigate("/admin/content-management");
        break;
      case "payments":
        navigate("/admin/payment-list");
        break;
      case "user-profile":
        // Don't navigate away from current user profile
        if (!location.pathname.includes("/admin/user-profile/")) {
          navigate("/admin/user-management");
        }
        break;
      default:
        navigate("/admin/dashboard");
    }
  };

  const renderContent = () => {
    console.log("Rendering content for section:", activeSection);
    
    switch (activeSection) {
      case "dashboard":
        return <DashboardSection />;
      case "users":
        return <UserManagementSection />;
      case "approvals":
        return <ContentApprovalsSection />;
      case "reports":
        return <ReportsModerationSection />;
      case "subscriptions":
        return <SubscriptionPlansSection />;
      case "cms":
        return <ContentManagementSection />;
      case "payments":
        return <PaymentList />;
      case "user-profile":
        return <UserProfile />;
      default:
        return <DashboardSection />;
    }
  };

  const handleLogout = () => {
    dispatch(
      logout({
        isAuthenticated: false,
        user: null,
        token: null,
        loading: false,
        error: null,
        sessionChecked: false,
      })
    );
    navigate("/login");
  };

  return (
    <div className="admin-layout-container">
      {/* Topbar - First at the very top */}
      <Topbar />
      
      {/* Main Area (Sidebar + Content) */}
      <div className="admin-main-area">
        {/* Sidebar */}
        <Sidebar 
          activeSection={activeSection} 
          setActiveSection={handleSectionChange} 
        />
        
        {/* Content Area */}
        <div className="admin-content-area">
          {/* Scrollable Content Only */}
          <div className="admin-scrollable-content">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardDetails;